import { GetServerSideProps } from "next";
import { ReactElement } from "react";
import BestMoversNearbyWrapper from "@components/layouts/bestMoversNearbyWrapper";

import { getPageProps } from "@services/initial-calls";
import TermsAndConditions from "@components/shared/legal/termsAndConditions";

export default function TermsAndConditionsHome(): ReactElement {
    return (
        <BestMoversNearbyWrapper>
            <TermsAndConditions
                category="Moving"
                domain="BestMoversNearby.com"
            />
        </BestMoversNearbyWrapper>
    );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
    return await getPageProps(context, "home", {
        pageTitle: "Terms And Conditions",
    });
};
